import { IBFRecordParsingDefinition } from "@/lib/drivers/insulet/IBFRecords/RecordParser";

export type IBFPumpProfileSettings = {
  profilesCount: number;
  activeProfileIdx: number;
  maxNameSize: number;
  profiles: {
    index: number;
    name: string;
    isActive: boolean;
  }[];
  rawProfiles: ArrayBuffer[];
};

export const IBF_PUMP_PROFILE_SETTINGS = {
  // Value is just the order in which the items are present in the file
  value: 4,
  name: "IBF_PUMP_PROFILE_SETTINGS",
  size: 9,
  parse: record => {
    const profilesCount = record.nextUInt16BE();
    const activeProfileIdx = record.nextUInt16BE();
    const maxNameSize = record.nextUInt16BE();
    const profileDefinition = IBF_PUMP_PROFILE_NAME(maxNameSize);
    const profiles: IBFPumpProfileName[] = [];
    const rawProfiles: ArrayBuffer[] = [];
    for (let i = 0; i < profilesCount; i++) {
      const profileRecordDefinition = record.subRecord(profileDefinition.size);
      profiles.push(profileDefinition.parse(profileRecordDefinition));
      rawProfiles.push(profileRecordDefinition.buffer.buffer);
    }

    return {
      profilesCount,
      activeProfileIdx,
      maxNameSize,
      profiles: profiles.map(profile => ({
        ...profile,
        isActive: profile.index === activeProfileIdx,
      })),
      rawProfiles,
    };
  },
} satisfies IBFRecordParsingDefinition<IBFPumpProfileSettings>;

type IBFPumpProfileName = {
  index: number;
  name: string;
};

const IBF_PUMP_PROFILE_NAME = (maxNameSize: number) =>
  ({
    value: 0,
    name: "IBF_PUMP_PROFILE_NAME",
    size: maxNameSize + 2,
    parse: record => {
      const index = record.nextUInt16BE();
      const name = record.nextString(maxNameSize);
      return {
        index,
        name,
      };
    },
  }) satisfies IBFRecordParsingDefinition<IBFPumpProfileName>;
